import ApplicationController from '../application_controller'

class RestrictionsController extends ApplicationController {
  static targets = ['selectUnits', 'warningMessage']

  connect () {
    this.reinitializeSelect2WithDeletedUnitsSupport('#user_related_unit_ids')
    this.handleWarning()

    $(document).on('change', '#user_related_unit_ids', () => {
      this.handleWarning()
    })
  }

  handleWarning () {
    if (this.hasSelectUnitsTarget) {
      const value = $(this.selectUnitsTarget).val()
      if (value.length === 0) {
        this.warningMessageTarget.classList.remove('d-none')
      } else {
        this.warningMessageTarget.classList.add('d-none')
      }
    }
  }

  reinitializeSelect2WithDeletedUnitsSupport (inputSelector) {
    const $ = window.$
    const $select = $(inputSelector)

    if ($select.length === 0) {
      return
    }

    setTimeout(() => {
      const currentValue = $select.val()
      const allowClear = $select.hasClass('select2-allow-clear')

      $select.select2('destroy')

      $select.select2({
        createSearchChoicePosition: 'top',
        width: 'copy',
        allowClear,
        dropdownCssClass: `${$select.attr('id')}_select2_results`,

        formatSelectionCssClass: (data, container) => {
          if (!data || !data.element) {
            return undefined
          }

          let element = data.element
          if (Array.isArray(element)) {
            element = element[0]
          }

          const $element = $(element)
          const isDeleted = $element.attr('data-deleted') === 'true'

          if (isDeleted) {
            return 'deleted-unit-choice'
          }

          return undefined
        },

        matcher: (params, data) => {
          if (params == null || params.trim() === '') {
            return data
          }

          if (typeof data.text !== 'string' || !data.text) {
            return null
          }

          const index = window.FlexSearch.Index({
            tokenize: 'full',
            charset: 'latin:strict'
          })

          index.add('0', data.text)

          if (index.search(params).length > 0) {
            return data
          }

          return null
        },

        escapeMarkup: (val) => val
      })

      $select.val(currentValue).trigger('change')

      const select2 = $select.data('select2')
      if (select2 && select2.search) {
        select2.search.attr({
          autocomplete: 'off',
          'data-lpignore': 'true',
          'data-form-type': 'other'
        })
      }

      if (select2) {
        const option = '.select2-search-choice>div, .select2-chosen'
        const result = '.select2-result-label'

        select2.selection.find(option).toHtmlTags()
        $select.on({
          'select2-loaded': () => select2.results && select2.results.find(result).toHtmlTags(),
          'select2-close': () => select2.selection && select2.selection.find(option).toHtmlTags(),
          'change.select2': () => select2.selection && select2.selection.find(option).toHtmlTags()
        })
      }
    }, 100)
  }
}

export default RestrictionsController
